import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  /* border-bottom: 1px solid ",
        "; */\n  color: ",
        ";\n  /* padding: 16px; */\n  vertical-align: middle;\n\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n  font-size: 16px;\n  font-weight: 400;\n  text-transform: uppercase;\n  height: 24px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import styled from "styled-components";
import { typography } from "styled-system";
export var Td = styled.td.withConfig({
    componentId: "sc-b51b3f0f-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white10;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, typography);
export var Th = styled(Td).attrs({
    as: "th"
}).withConfig({
    componentId: "sc-b51b3f0f-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.white;
});
